import { Button, MenuItem, Skeleton } from '@chakra-ui/react';
import { ExternalRegionLink, useExperiment } from '@acp/feature/auth';
import React from 'react';
import { Experiment } from '@acp/shared';
import { PropertyRequestModalOpenEvents } from './lazy-loaded/types';
import { PropertyRequestCreatorContext } from '../create-request/creator-machine/context';

type NewWorkOrderMenuItemProps = {
    legacyPath?: string;
    eventGenerator?: () => PropertyRequestModalOpenEvents;
} & React.ComponentProps<typeof Button>;

function MenuItemSkeleton({ children, ...props }: NewWorkOrderMenuItemProps) {
    return (
        <Skeleton>
            <MenuItem
                {...props}
            >
                { children }
            </MenuItem>
        </Skeleton>
    );
}

function NewWorkOrderMenuItem({ children, legacyPath, ...props }: NewWorkOrderMenuItemProps) {
    const { hasExperiment, isLoading } = useExperiment();
    const machine = PropertyRequestCreatorContext.useActorRef();

    if (isLoading) {
        return <MenuItemSkeleton {...props}>{children}</MenuItemSkeleton>;
    }

    if (!hasExperiment(Experiment.PropertyRequestEnrolmentV1)) {
        return (
            <MenuItem
                as={ExternalRegionLink}
                path={legacyPath ?? '/JobOrders/add'}
                target="_blank"
                textDecoration="none"
                {...props}
            >
                {children}
            </MenuItem>
        );
    }

    return (
        <MenuItem
            {...props}
            onClick={(e) => {
                props.onClick?.(e);

                if (props.eventGenerator !== undefined) {
                    machine.send(props.eventGenerator());
                    return;
                }

                machine.send({
                    type: 'OPEN',
                });
            }}
        >
            {children}
        </MenuItem>
    );
}

export { NewWorkOrderMenuItem };
